var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var _a;
import { useWeb3React as useEVMWallet } from "@web3-react/core";
import { injectedConnector, } from "../utils/connectors";
import { useCallback, useEffect, useState } from "react";
import { WalletConnectConnector } from "@web3-react/walletconnect-connector";
import { useWallet as useSolanaWallet } from "@solana/wallet-adapter-react";
import { WalletName } from "@solana/wallet-adapter-wallets";
import { useChain } from "./chainContext";
import { EthereumWallet, isEthereumWallet, isSolanaWallet, SolanaWallet, } from "../models/wallets";
import { Chains, CHAINS_TO_ID, ID_TO_CHAINS } from "../constants/constants";
import { switchChains } from "../utils/chainSwitching";
import { impersonateAddress } from "../utils/development";
import { isLedgerDappBrowserProvider } from "web3-ledgerhq-frame-connector";
export var useWeb3Wallet = function () {
    var _a = useChain(), chain = _a[0], setChain = _a[1];
    var _b = useState(null), chainToSwitch = _b[0], setChainToSwitch = _b[1];
    var _c = useState(), connectingWallet = _c[0], setConnectingWallet = _c[1];
    var _d = useState(), connectedWallet = _d[0], setConnectedWallet = _d[1];
    var _e = useEVMWallet(), chainIdEth = _e.chainId, isActiveEth = _e.active, activateEth = _e.activate, accountEth = _e.account, libraryEth = _e.library, _deactivateEth = _e.deactivate, connectorEth = _e.connector;
    var _f = useSolanaWallet(), walletSolana = _f.wallet, isActiveSolana = _f.connected, deactivateSolana = _f.disconnect, publicKeySolana = _f.publicKey, selectWalletSolana = _f.select;
    // This hook manages the entire multi-chain flow
    // It checks when an active provider is available and sets the global chainContext accordingly
    useEffect(function () {
        // console.group("useWeb3Wallet useEffect");
        // console.log("isActiveEth:", isActiveEth)
        // console.log("chainIdEth:", chainIdEth)
        // console.log("ID_TO_CHAINS:", ID_TO_CHAINS)
        // console.log("chainIdEth:", chainIdEth)
        // console.log("setChain:", setChain)
        // console.groupEnd();
        if (isActiveEth && chainIdEth) {
            setChain(ID_TO_CHAINS[chainIdEth]);
        }
        else if (isActiveSolana && !chainIdEth) {
            setChain(Chains.Solana);
        }
    }, [chainIdEth, isActiveEth, isActiveSolana, setChain]);
    // This hook checks if there is an EVM chainId to switch to
    // If so, it will prompt switchChains only when a provider is available
    useEffect(function () {
        var onSwitchChains = function () { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: 
                    // console.log("CHAINS_TO_ID", CHAINS_TO_ID);
                    // console.log("chainToSwitch", chainToSwitch);
                    // console.log("Chains", Chains);
                    return [4 /*yield*/, switchChains(libraryEth, CHAINS_TO_ID[chainToSwitch])];
                    case 1:
                        // console.log("CHAINS_TO_ID", CHAINS_TO_ID);
                        // console.log("chainToSwitch", chainToSwitch);
                        // console.log("Chains", Chains);
                        _a.sent();
                        setChainToSwitch(null);
                        return [2 /*return*/];
                }
            });
        }); };
        if (chainToSwitch && libraryEth) {
            onSwitchChains();
        }
    }, [libraryEth, chainToSwitch]);
    var deactivateEth = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!connectorEth) return [3 /*break*/, 3];
                    if (!(connectorEth instanceof WalletConnectConnector)) return [3 /*break*/, 2];
                    return [4 /*yield*/, connectorEth.close()];
                case 1:
                    _a.sent();
                    _a.label = 2;
                case 2:
                    _deactivateEth();
                    setConnectedWallet(undefined);
                    _a.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    }); }, [connectorEth, _deactivateEth]);
    var activate = useCallback(function (wallet, chain) { return __awaiter(void 0, void 0, void 0, function () {
        var connector, walletName, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    // console.log("activate 1");
                    setConnectingWallet(wallet);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 9, , 10]);
                    if (!isEthereumWallet(wallet)) return [3 /*break*/, 5];
                    if (!!isActiveEth) return [3 /*break*/, 3];
                    connector = evmConnectors[wallet]();
                    return [4 /*yield*/, activateEth(connector)];
                case 2:
                    _a.sent();
                    _a.label = 3;
                case 3: return [4 /*yield*/, deactivateSolana()];
                case 4:
                    _a.sent();
                    setChainToSwitch(chain);
                    setConnectedWallet(wallet);
                    return [3 /*break*/, 8];
                case 5:
                    if (!isSolanaWallet(wallet)) return [3 /*break*/, 7];
                    walletName = WalletName.Phantom;
                    switch (wallet) {
                        case SolanaWallet.Phantom:
                            walletName = WalletName.Phantom;
                            break;
                        case SolanaWallet.Solflare:
                            walletName = WalletName.Solflare;
                            break;
                    }
                    return [4 /*yield*/, deactivateEth()];
                case 6:
                    _a.sent();
                    selectWalletSolana(walletName);
                    return [3 /*break*/, 8];
                case 7: 
                // console.log("activate 6");
                throw new Error("Wallet is not supported");
                case 8:
                    setConnectedWallet(wallet);
                    setConnectingWallet(undefined);
                    return [3 /*break*/, 10];
                case 9:
                    error_1 = _a.sent();
                    // console.log("activate 7");
                    console.error(error_1); // eslint-disable-line
                    return [3 /*break*/, 10];
                case 10: return [2 /*return*/];
            }
        });
    }); }, [
        activateEth,
        deactivateEth,
        deactivateSolana,
        isActiveEth,
        selectWalletSolana,
    ]);
    if (chain === Chains.Solana) {
        return {
            chainId: undefined,
            active: isActiveSolana,
            account: publicKeySolana && publicKeySolana.toString(),
            activate: activate,
            deactivate: deactivateSolana,
            connectingWallet: connectingWallet,
            connectedWallet: connectedWallet,
            ethereumProvider: undefined,
            ethereumConnector: undefined,
            solanaWallet: walletSolana || undefined,
            isLedgerLive: false,
        };
    }
    return {
        chainId: chainIdEth,
        active: isActiveEth,
        activate: activate,
        deactivate: deactivateEth,
        account: impersonateAddress !== null && impersonateAddress !== void 0 ? impersonateAddress : accountEth,
        connectingWallet: connectingWallet,
        connectedWallet: connectedWallet,
        ethereumProvider: libraryEth,
        ethereumConnector: connectorEth,
        solanaWallet: undefined,
        isLedgerLive: isLedgerDappBrowserProvider(),
    };
};
var evmConnectors = (_a = {},
    _a[EthereumWallet.Metamask] = function () { return injectedConnector; },
    _a);
export default useWeb3Wallet;
//# sourceMappingURL=useWeb3Wallet.js.map